"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    {
        inputs: [],
        name: "ZeroAddress",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldAcross",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAcross",
                type: "address",
            },
        ],
        name: "AcrossUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldBurnRouter",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newBurnRouter",
                type: "address",
            },
        ],
        name: "BurnRouterUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "newChain",
                type: "uint256",
            },
        ],
        name: "ChainAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldChain",
                type: "uint256",
            },
        ],
        name: "ChainRemoved",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "lockerTargetAddress",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "recipientAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address[2]",
                name: "inputAndOutputToken",
                type: "address[2]",
            },
            {
                indexed: false,
                internalType: "uint256[2]",
                name: "inputAndOutputAmount",
                type: "uint256[2]",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "speed",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "teleporter",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "bitcoinTxId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "appId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "thirdPartyId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256[5]",
                name: "fees",
                type: "uint256[5]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "destinationChainId",
                type: "uint256",
            },
        ],
        name: "FailedWrapAndSwap",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "txId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "time",
                type: "uint256",
            },
        ],
        name: "FillStarted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "remainingAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "filler",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "fillIdx",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "txId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "reqMintedTeleBtc",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "sentTeleBtc",
                type: "uint256",
            },
        ],
        name: "FillTeleBtcSent",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "filler",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "fillIdx",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "txId",
                type: "bytes32",
            },
        ],
        name: "FillTokensReturned",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "destinationChain",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "mappedChainId",
                type: "uint256",
            },
        ],
        name: "NewChainIdMapping",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "filler",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "txId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "NewFill",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldFillerWithdrawInterval",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newFillerWithdrawInterval",
                type: "uint256",
            },
        ],
        name: "NewFillerWithdrawInterval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldLockers",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newLockers",
                type: "address",
            },
        ],
        name: "NewLockers",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldProtocolPercentageFee",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newProtocolPercentageFee",
                type: "uint256",
            },
        ],
        name: "NewProtocolPercentageFee",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldRelay",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newRelay",
                type: "address",
            },
        ],
        name: "NewRelay",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldSpecialTeleporter",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newSpecialTeleporter",
                type: "address",
            },
        ],
        name: "NewSpecialTeleporter",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldTeleBTC",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newTeleBTC",
                type: "address",
            },
        ],
        name: "NewTeleBTC",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "thirdPartyId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "oldThirdPartyAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newThirdPartyAddress",
                type: "address",
            },
        ],
        name: "NewThirdPartyAddress",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "thirdPartyId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "oldThirdPartyFee",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newThirdPartyFee",
                type: "uint256",
            },
        ],
        name: "NewThirdPartyFee",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldTreasury",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newTreasury",
                type: "address",
            },
        ],
        name: "NewTreasury",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "lockerTargetAddress",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address[2]",
                name: "inputAndOutputToken",
                type: "address[2]",
            },
            {
                indexed: false,
                internalType: "uint256[2]",
                name: "inputAndOutputAmount",
                type: "uint256[2]",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "speed",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "teleporter",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "bitcoinTxId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "appId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "thirdPartyId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256[5]",
                name: "fees",
                type: "uint256[5]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "destinationChainId",
                type: "uint256",
            },
        ],
        name: "NewWrapAndSwap",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldWrappedNativeToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newWrappedNativeToken",
                type: "address",
            },
        ],
        name: "NewWrappedNativeToken",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "appId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "exchangeConnector",
                type: "address",
            },
        ],
        name: "SetExchangeConnector",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newToken",
                type: "address",
            },
        ],
        name: "TokenAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "oldToken",
                type: "address",
            },
        ],
        name: "TokenRemoved",
        type: "event",
    },
    {
        inputs: [],
        name: "across",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "burnRouter",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "chainId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "chainIdMapping",
        outputs: [
            {
                internalType: "uint256",
                name: "middleChain",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "destinationChain",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "exchangeConnector",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "extendedCcExchangeRequests",
        outputs: [
            {
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "isTransferredToOtherChain",
                type: "bool",
            },
            {
                internalType: "uint256",
                name: "remainedInputAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "bridgeFee",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "thirdParty",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "protocolFee",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "thirdPartyFee",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "lockerFee",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "fillerWithdrawInterval",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "fillersData",
        outputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "fillsData",
        outputs: [
            {
                internalType: "uint256",
                name: "startingTime",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "reqToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "lastUsedIdx",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "remainingAmountOfLastFill",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "isWithdrawnLastFill",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
        ],
        name: "getDestChainId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_startingBlockNumber",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_protocolPercentageFee",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_chainId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_lockers",
                type: "address",
            },
            {
                internalType: "address",
                name: "_relay",
                type: "address",
            },
            {
                internalType: "address",
                name: "_teleBTC",
                type: "address",
            },
            {
                internalType: "address",
                name: "_treasury",
                type: "address",
            },
            {
                internalType: "address",
                name: "_across",
                type: "address",
            },
            {
                internalType: "address",
                name: "_burnRouter",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "isChainSupported",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_txId",
                type: "bytes32",
            },
        ],
        name: "isRequestUsed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "isTokenSupported",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lockers",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "prefixFillSums",
        outputs: [
            {
                internalType: "uint256",
                name: "currentIndex",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "protocolPercentageFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "relay",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_chainId",
                type: "uint256",
            },
        ],
        name: "removeChain",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
        ],
        name: "removeToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_message",
                type: "bytes",
            },
            {
                internalType: "bytes32",
                name: "_r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "_s",
                type: "bytes32",
            },
            {
                internalType: "uint8",
                name: "_v",
                type: "uint8",
            },
        ],
        name: "retryFailedWrapAndSwap",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_across",
                type: "address",
            },
        ],
        name: "setAcross",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_burnRouter",
                type: "address",
            },
        ],
        name: "setBurnRouter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_destinationChain",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_mappedId",
                type: "uint256",
            },
        ],
        name: "setChainIdMapping",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_appId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_exchangeConnector",
                type: "address",
            },
        ],
        name: "setExchangeConnector",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_lockers",
                type: "address",
            },
        ],
        name: "setLockers",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_protocolPercentageFee",
                type: "uint256",
            },
        ],
        name: "setProtocolPercentageFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_relay",
                type: "address",
            },
        ],
        name: "setRelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_specialTeleporter",
                type: "address",
            },
        ],
        name: "setSpecialTeleporter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_startingBlockNumber",
                type: "uint256",
            },
        ],
        name: "setStartingBlockNumber",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_teleBTC",
                type: "address",
            },
        ],
        name: "setTeleBTC",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_thirdPartyId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_thirdPartyAddress",
                type: "address",
            },
        ],
        name: "setThirdPartyAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_thirdPartyId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_thirdPartyFee",
                type: "uint256",
            },
        ],
        name: "setThirdPartyFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_treasury",
                type: "address",
            },
        ],
        name: "setTreasury",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_wrappedNativeToken",
                type: "address",
            },
        ],
        name: "setWrappedNativeToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "specialTeleporter",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "startingBlockNumber",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_chainId",
                type: "uint256",
            },
        ],
        name: "supportChain",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
        ],
        name: "supportToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "teleBTC",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "thirdPartyAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "thirdPartyFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "treasury",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_message",
                type: "bytes",
            },
            {
                internalType: "bytes32",
                name: "_r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "_s",
                type: "bytes32",
            },
            {
                internalType: "uint8",
                name: "_v",
                type: "uint8",
            },
            {
                internalType: "bytes",
                name: "_lockerLockingScript",
                type: "bytes",
            },
        ],
        name: "withdrawFailedWrapAndSwap",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bytes4",
                        name: "version",
                        type: "bytes4",
                    },
                    {
                        internalType: "bytes",
                        name: "vin",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes",
                        name: "vout",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes4",
                        name: "locktime",
                        type: "bytes4",
                    },
                    {
                        internalType: "uint256",
                        name: "blockNumber",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "intermediateNodes",
                        type: "bytes",
                    },
                    {
                        internalType: "uint256",
                        name: "index",
                        type: "uint256",
                    },
                ],
                internalType: "struct ICcExchangeRouter.TxAndProof",
                name: "_txAndProof",
                type: "tuple",
            },
            {
                internalType: "bytes",
                name: "_lockerLockingScript",
                type: "bytes",
            },
            {
                internalType: "address[]",
                name: "_path",
                type: "address[]",
            },
        ],
        name: "wrapAndSwap",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "wrappedNativeToken",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
//# sourceMappingURL=CCExchangeRouter.js.map